import { lazy, Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import { EditorResourcesBoundary } from '@/components/loading/EditorResourcesBoundary';

const loadEditorPage = () =>
  import('./EditorPage').then(({ EditorPage }) => ({ default: EditorPage }));
const EditorPage = lazy(loadEditorPage);

/** Different challenge history entries must load their own attempt. Chip/circuit
 * URL updates within one attempt retain the mounted editor and local mode. */
export function EditorRoute() {
  const [params] = useSearchParams();
  const attempt = params.get('challengeAttempt');
  return (
    <Suspense fallback={<main role="status">Opening editor…</main>}>
      <EditorResourcesBoundary prepareModule={loadEditorPage}>
        <EditorPage key={attempt === null ? 'ordinary-project' : `attempt:${attempt}`} />
      </EditorResourcesBoundary>
    </Suspense>
  );
}
